import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ai-button',
  standalone: true,
  imports: [],
  templateUrl: './ai-button.component.html',
  styleUrl: './ai-button.component.scss',
})
export class AiButtonComponent {
  @Input() disabled = false;
  @Input() fontClass: string = 'font-2';
  @Output() buttonClick = new EventEmitter<void>();
  iconPath = ICON_PATH;

  buttonClickEmitter(): void {
    if (this.disabled) {
      return;
    }

    this.buttonClick.emit();
  }
}

const ICON_PATH = '/assets/svg/optimized/ai-star.svg';
